<template>
	<div class="UserHeaderInformation-box">
		<div class="background_wall" @click.stop="check_bg_img(InformationData)">
			<img v-if="InformationData.bg_img" :src="InformationData.bg_img" :alt="'TOZO Community ' + InformationData.nickname + ' User background image'"/>
			<img v-else :src="DefaultBackground" alt="Default user background image in TOZO community"/>
		</div>
		<div class="UserInformation-box">
			<div class="UserInformation-left">
			  <div class="avatar" :class="!InformationData.avatar ? 'no_avatar_img' : ''" @click.stop="check_information(InformationData)">
					<img v-if="InformationData.avatar && InformationData.avatar != ''" :src="InformationData.avatar" :alt="'TOZO Community ' + InformationData.nickname + ' User Avatar'"/>
					<i v-else class="el-icon-s-custom"></i>
			  </div>
			</div>
			<div class="right-box">
				<div class="UserInformation-center">
					<div class="name">{{ InformationData.nickname }}</div>
					<div class="browse_browse_box">
						<div class="icon_box" :class="Is_it_oneself() ? 'is_it_me' : ''" @click.stop="thumb_fun(InformationData)">
							<div class="icon_box_num">{{ InformationData.thumb }}</div>
							<div class="icon_box_text">{{ $t('PersonalArr.Likes') }}</div>
						</div>
						<div class="icon_box" :class="Is_it_oneself() ? 'is_it_me' : ''" @click.stop="focus_fun(InformationData)">
							<div class="icon_box_num">{{ InformationData.focus }}</div>
							<div class="icon_box_text">{{ $t('PersonalArr.Followers') }}</div>
						</div>
						<div class="icon_box" :class="Is_it_oneself() ? 'is_it_me' : ''" @click.stop="followers_fun(InformationData)">
							<div class="icon_box_num">{{ InformationData.followers }}</div>
							<div class="icon_box_text">{{ $t('PersonalArr.Fans') }}</div>
						</div>
					</div>
					<div class="product_list" v-if="InformationData.product">
						<div class="product_name" v-for="(item, index) in InformationData.product">{{ item }}</div>
					</div>
				</div>
				<div class="UserInformation-right" v-if="Information_user_id">
					<div class="modify_personal_information_box" v-if="Is_it_oneself()">
						<div class="modify_personal_information" @click="modify_personal_information()">
							{{ $t('buttonArr.Edit') }}
						</div>
					</div>
					<div class="right_box" v-else>
						<div class="follow_status_box" :class="parent_type == 'follow' ? 'follow_box' : 'following_followers'">
							<div class="follow_status" @click.stop="change_state(InformationData)" :class="InformationData.is_follow == 1 ? 'Unfollow' : 'Follow'">
								{{ InformationData.is_follow == 1 ? $t('buttonArr.Unfollow') : $t('buttonArr.Follow') }}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		
		<handlePreviewSwiper v-if="handlePreviewShow" :fileList="PreviewSwiper" :currentUrl="currentUrl" :itemtype="swiperSlide" @closurePreview="handlePreviewShow = false"></handlePreviewSwiper>
		
		<!-- <div class="check_avatar_box" v-if="check_img && check_img != ''">
			<div class="check_avatar_header">
				<i class="el-icon-close" @click="close_avatar()"></i>
			</div>
			<div class="check_avatar">
				<img :src="check_img" alt="check_img">
			</div>
		</div> -->
	</div>
</template>

<script>
// import TopNavbar from './components/TopNavbar.vue'
import { post_community_userhome, post_community_userfollow } from '@/api/community.js'

export default {
	name: 'UserHeaderInformation',
	// components: { TopNavbar },

	props: {
		Information_user_id: {
			default: "",
		},
		parent_type: {
			type: String,
			default: "",
		},
	},
	data() {
		return {
			is_it_me: true,
			InformationData: {
				user_id: "",
				avatar: "", //头像
				nickname: "", //昵称
				thumb: "", //点赞数
				focus: "", //关注数
				followers: "", //粉丝数
				is_follow: "", //是否关注, 0否, 1是
				is_official: "", //是否官方账号, 0否, 1是
				bg_img: "", //背景图
			},
			//默认的背景图
			DefaultBackground: "https://s3-us-tozo-test-wr.tozostore.com/Admin/app30/img/202501080313151515_17363059959i6lRB2VFEv8rKcy.png",
			check_img: "",
			PreviewSwiper:[],
			currentUrl: "",
			handlePreviewShow: false,
			swiperSlide: "",
		}
	},
	
	// 监听
	watch: {
		"Information_user_id": {
			handler: function (newValue, oldValue) {
				this.clear_data()
			},
			deep: true
		},
		"$route": {
			handler: function (newValue, oldValue) {
				this.dialogVisible = false
			},
			deep: true
		},
	},
	
	// beforeCreate() {
		
	// }
	
	// 路由返回刷新数据 // 页面激活
	activated() {
		console.log('路由返回刷新数据')// 当路由更新时，更新 userId 数据
		this.set_user_id()
		this.get_data_list()
	},
	
	
	beforeRouteUpdate(to, from, next) {
		// 当路由更新时，更新 userId 数据
		this.set_user_id()
		next();
	},
	
	created () {
	  
	},
  
	mounted() {
		this.clear_data()
	},
  
	methods:{
		OpenPreviewSwiper(fileList, item, swiperSlide){
			// let currentRouteName = this.$route.name;
			// if(currentRouteName != 'PostDetails'){ return }
			this.PreviewSwiper = fileList
			this.currentUrl = item
			this.handlePreviewShow = true
			this.swiperSlide = swiperSlide
		},
		
		set_user_id(){
			if(this.$route.params.user_id){
				this.InformationData.user_id = this.$route.params.user_id
			}else if(this.Information_user_id){
				this.InformationData.user_id = this.Information_user_id
			}else{
				this.InformationData.user_id = ''
			}
			return this.InformationData.user_id
		},
		
		clear_data(){
			Object.keys(this.InformationData).forEach(key => {
			   this.InformationData[key] = '';
			});
			this.set_user_id()
			this.get_data_list()
		},
		
		//获取列表
		get_data_list(){
			console.log(this.InformationData.user_id)
			if(!this.InformationData.user_id){ return }
			let obj = {
				user_id : this.InformationData.user_id
			}
			post_community_userhome(obj)
		   .then((res) => {
				console.log(res)
				this.loading = false
				if(res.code == 0 && res.data){
					this.InformationData = res.data
					let nickname = this.InformationData.nickname ? `User homepage of ${this.InformationData.nickname}` : ""
					this.$setTags.updateMetaDescription(nickname || "")
					this.set_user_id()
					this.seo_userInfo_data(this.InformationData)
				}else{
					this.exception_handling(res)
				}
		   })
		   .catch((err) => {
				console.log(err)
				this.exception_handling(err)
		   })
		},
		
		//异常处理
		exception_handling(err){
			this.loading = false
			this.$errorMessage(err)
			// this.$message('err.data.message', 'error')
		},
		
		// SEO数据结构化 - 用户信息
		seo_userInfo_data(InformationData) {
		   console.log(InformationData);
		   if (!InformationData) {
		      return;
		   }
		
		   // 检查是否已经存在该用户的结构化数据脚本
		   const existingScripts = document.querySelectorAll('script[type="application/ld+json"]');
		   let isDuplicate = false;
		   const currentUserId = InformationData.user_id;
		   existingScripts.forEach(script => {
		      try {
		         const existingData = JSON.parse(script.textContent);
		            if (existingData.user_id === currentUserId) {
		               isDuplicate = true;
		            }
		        } catch (error) {
		         // 解析失败，忽略该脚本
		        }
		   });
		
		   if (!isDuplicate) {
		      const structuredData = {
		         "@context": "https://schema.org",
		         "@type": "ProfilePage",
		         "user_id": InformationData.user_id || "", // id
		         "name": InformationData.nickname || "", // 昵称
		         "image": InformationData.avatar || "", // 头像
		         "description": InformationData.description || "", // 描述
		         "bg_img": InformationData.bg_img || "", // 背景图
		         "focus": InformationData.focus || "", // 关注者
		         "followers": InformationData.followers || "", // 粉丝
		         "thumb": InformationData.thumb || "", // 获赞
		         // "sameAs": this.user.socialLinks.map(link => link.url)
		      };
		
		      const script = document.createElement('script');
		      script.type = 'application/ld+json';
		      script.textContent = JSON.stringify(structuredData);
		      document.head.appendChild(script);
		   }
		},
		
		// 判读是否是当前用户
		Is_it_oneself(){
			return this.$store.state.userinfo.user_id == this.InformationData.user_id
		},
		
		//查看 粉丝或关注人信息
		check_information(InformationData){
			console.log(InformationData)
			if(InformationData.avatar && InformationData.avatar != ''){
				this.check_img = InformationData.avatar
				this.handlePreview(this.check_img)
			}
		},
		
		//查看 背景图
		check_bg_img(InformationData){
			console.log(InformationData)
			if(InformationData.bg_img && InformationData.bg_img != ''){
				this.check_img = InformationData.bg_img
			}else{
				this.check_img = this.DefaultBackground
			}
			console.log(this.check_img)
			this.handlePreview(this.check_img)
		},
		
		// 点击查看大图
		handlePreview(url) {
			// 整理数据结构兼容帖子列表的结构
			let pics = [
				{
					width: 0,
					height: 0,
					url: url,
					video: "",
					ios_url: "",
				}
			]
			let fileList = {
			   videos: [], //视频
			   video_cover: "", //视频封面
				post_type: 1, //类型
			   SlideTotal: 1,
			   pics: pics
			}
			console.log(fileList)
			this.OpenPreviewSwiper(fileList, url, 'UploadImg')
		},
	
		//关闭头像展示
		close_avatar(){
			this.check_img = ''
		},
	
		//更新当前状态
		change_state(item){
			console.log(item)
			this.post_community_userfollow(item)
			// console.log(this.page_name)
			// if(this.page_name == 'Home'  || this.page_name == 'OtherUsers'){
			// 	this.post_community_userfollow(item)
			// }else if(this.page_name == 'FanHomePage'){
			// 	this.change_FanHomePage(item)
			// }else if(this.page_name == 'recommand'){
			// 	this.change_FollowList(item)
			// }
		},
			
		//用户关注
		post_community_userfollow(item){
			console.log(item)
			let obj = {
				user_id: item.user_id, 
				status: item.is_follow == 0 ? 1 : 2, //是否关注, is_follow:0否, 1是,  status: 1关注, 2取关
			}
			console.log(obj)
			post_community_userfollow(obj)
			.then((res) => {
				console.log(res)
				if(res.code == 0){
					this.get_data_list()
					this.$emit('operations', 'success')
				}else{
					this.exception_handling(res, "userfollow")
				}
			})
			.catch((err) => {
				console.log(err)
				this.exception_handling(err, "userfollow")
			})
		},
	
		//查看获赞
		thumb_fun(item){
			console.log('thumb_fun')	
			console.log(item)	
			// if(this.Is_it_oneself()){
			// 	this.$router.push({
			// 		name: "follow-list",
			// 		params: {}
			// 	})
			// }
		},
	
		//查看关注
		focus_fun(item){
			console.log('focus_fun')	
			console.log(item)	
			if(this.Is_it_oneself()){
				this.$router.push({
					name: "follow-list",
					params: {}
				})
			}
		},
	
		//查看粉丝
		followers_fun(item){
			console.log('followers_fun')	
			console.log(item)	
			if(this.Is_it_oneself()){
				this.$router.push({
					name: "fans-list",
					params: {}
				})
			}
		},
		
		//修改个人信息
		modify_personal_information(item){
			this.$router.push({
				name: "edit-personal-information",
				params: {
					// routeName: 'add' + '_' + '添加产品基本信息',
					// page: this.listQuery.page,
				}
			})
		},
	
	
	}
}
</script>

<style lang="less" scoped>
	*{
		box-sizing: border-box;
		font-family: Poppins, Poppins;
	}
	.check_avatar_box{
		z-index: 999999;
		width: 100vw;
		height: 100vh;
		position: fixed;
		top: 0;
		left: 0;
		display: flex;
		justify-content: center;
		flex-direction: column;
		background-color: rgba(0, 0,0, 0.8);
		.check_avatar_header{
			z-index: 999999;
			width: 100%;
			display: flex;
			justify-content: flex-end;
			.el-icon-close{
				color: #fff;
				display: flex;
				justify-content: center;
				align-items: center;
				cursor: pointer;
			}
		}
		.check_avatar{
			z-index: 888;
			width: 100%;
			display: flex;
			justify-content: center;
			align-items: center;
			img{
				width: 100%;
			}
		}
	}
	
	@media screen and (min-width: 1025px) {
		.avatar{
			width: 96px;
			height: 96px;
			display: flex;
			justify-content: center;
			align-items: center;
			border-radius: 50%;
			cursor: pointer;
			img{
				width: 100%;
				height: 100%;
				max-width: 96px;
				max-height: 96px;
				border-radius: 50%;
				object-fit: cover;
			}
		}
	}
	@media screen and (max-width: 1024px) {
		.avatar{
			margin-top: -45px;
			width: 70px;
			height: 70px;
			display: flex;
			align-items: center;
			justify-content: center;
			border-radius: 50%;
			cursor: pointer;
			img{
				width: 100%;
				height: 100%;
				max-width: 70px;
				max-height: 70px;
				border-radius: 50%;
				object-fit: cover;
			}
		}
	}
	
	
	@media screen and (min-width: 1025px) {
		.check_avatar_box{
			height: calc(100vh - 0px);
			top: 0px;
			.check_avatar_header{
				z-index: 999999;
				height: 50px;
				.el-icon-close{
					color: #fff;
					width: 50px;
					height: 50px;
					margin-right: 15px;
					display: flex;
					cursor: pointer;
					font-size: 30px;
				}
			}
			.check_avatar{
				width: 100%;
				height: calc(100% - 50px);
				img{
					max-width: 600px;
					height: auto;
					object-fit: cover;
					width: 100%;
				}
			}
		}
		.UserHeaderInformation-box {
			width: 100%;
			display: flex;
			flex-direction: column;
			border-radius: 8px;
			overflow: hidden;
		}
		.background_wall{
			width: 100%;
			height: 100%;
			min-height: 260px;
			max-height: 260px;
			z-index: 0;
			cursor: pointer;
			img{
				width: 100%;
				height: 100%;
				max-height: 260px;
				min-height: 260px;
				object-fit: cover;
			}
		}
		.UserInformation-box{
			padding: 10px 18px 13px 18px;
			background-color: #ffffff;
			z-index: 9;
			display: flex;
			width: 100%;
			.UserInformation-left{
				width: 96px;
				border-radius: 50%;
				.avatar{
					/* margin-top: -calc(calc(96px + 10px) / 2); */
					margin-top: -60px;
					width: 96px;
					height: 96px;
					display: flex;
					justify-content: center;
					align-items: center;
					border-radius: 50%;
					cursor: pointer;
					img{
						width: 100%;
						height: 100%;
						max-width: 96px;
						max-height: 96px;
						border-radius: 50%;
						object-fit: cover;
					}
				}
				.no_avatar_img{
					cursor: default;
					border: 1px #f1f1f1 solid;
					background-color: #ffffff;
				}
				.el-icon-s-custom{
					margin-top: -10px;
					font-size: 40px;
				}
			}
			.right-box{
				display: flex;
				margin-left: 20px;
				width: 100%;
				justify-content: space-between
				/* width: calc(100% - 206px); */
			}
			.UserInformation-center{
				width: 100%;
				.name{
					font-weight: 600;
					font-size: 16px;
					color: #111111;
					line-height: 22px;
					text-align: left;
					font-style: normal;
					text-transform: none;
				}
				.browse_browse_box{
					display: flex;
					margin-top: 5px;
					.is_it_me{
						cursor: pointer;
					}
					.icon_box{
						display: flex;
						font-weight: 400;
						font-size: 12px;
						color: #111111;
						line-height: 17px;
						text-align: left;
						font-style: normal;
						text-transform: none;
						margin-right: 26px;
						&:last-child{
							margin-right: 0px;
						}
					}
					.icon_box_text{
						margin-left: 5px;
					}
				}
				.product_list{
					margin-top: 10px;
					display: flex;
					flex-wrap: wrap;
					.product_name{
						font-weight: 400;
						margin-right: 5px;
						margin-bottom: 5px;
						font-size: 8px;
						color: #000000;
						line-height: 8px;
						padding: 3px 15px;
						border-radius: 10px;
						text-align: left;
						font-style: normal;
						text-transform: none;
						border: 1px #000000 solid;
						&:last-child{
							margin-right: 0px;
						}
					}
				}
			}
			.UserInformation-right{
				width: 80px;
				display: flex;
				justify-content: center;
				align-items: center;
				margin-left: 10px;
			}
			.modify_personal_information_box{
				width: 100%;
				height: 100%;
				display: flex;
				justify-content: center;
				align-items: center;
				.modify_personal_information{
					width: 80px;
					height: 28px;
					font-weight: 400;
					font-size: 12px;
					color: #FFFFFF;
					line-height: 14px;
					text-align: center;
					font-style: normal;
					text-transform: none;
					padding: 5px 15px;
					color: #ffffff;
					background: #000000;
					border: 1px #000000 solid;
					border-radius: 15px 15px 15px 15px;
					cursor: pointer;
				}
			}
			.follow_status_box{
				display: flex;
				justify-content: center;
				align-items: center;
				.follow_status{
					width: 80px;
					height: 28px;
					font-weight: 400;
					font-size: 12px;
					color: #FFFFFF;
					line-height: 14px;
					text-align: center;
					font-style: normal;
					text-transform: none;
					padding: 5px 15px;
					border-radius: 15px 15px 15px 15px;
					cursor: pointer;
				}
				.Follow{
					color: #ffffff;
					background: #06f;
					border: 1px #06f solid;
					// background: #2094FA;
					// border: 1px #2094FA solid;
				}
				.Remove{
					color: #ffffff;
					background: #000000;
					border: 1px #000000 solid;
				}
				.Unfollow{
					color: #06f;
					background: #ffffff;
					border: 1px #06f solid;
					// color: #2094FA;
					// background: #ffffff;
					// border: 1px #2094FA solid;
				}
			}
		}
	}
	
	@media screen and (max-width: 1023px) {
		.check_avatar_box{
			height: calc(100vh - 0px);
			top: 0px;
			background-color: rgba(0, 0,0, 0.8);
			.check_avatar_header{
				z-index: 999999;
				height: 45px;
				.el-icon-close{
					color: #fff;
					width: 45px;
					height: 45px;
					display: flex;
					cursor: pointer;
					font-size: 30px;
				}
			}
			.check_avatar{
				width: 100%;
				height: calc(100% - 45px);
				img{
					max-width: calc(100vw - 20px);
					max-height: calc(100vh - 50px);
					object-fit: cover;
					width: 100%;
				}
			}
		}
		.UserHeaderInformation-box {
			width: 100%;
			display: flex;
			flex-direction: column;
			border-radius: 8px;
			overflow: hidden;
		}
		.background_wall{
			width: 100%;
			height: 100%;
			min-height: 200px;
			max-height: 200px;
			z-index: 0;
			img{
				width: 100%;
				height: 100%;
				min-height: 200px;
				max-height: 200px;
				object-fit: cover;
			}
		}
		.UserInformation-box{
			padding: 10px 12px 13px 12px;
			background-color: #ffffff;
			z-index: 9;
			display: flex;
			width: 100%;
			.UserInformation-left{
				width: 70px;
				border-radius: 50%;
				.avatar{
					/* margin-top: -calc(calc(96px + 10px) / 2); */
					margin-top: -45px;
					width: 70px;
					height: 70px;
					display: flex;
					align-items: center;
					justify-content: center;
					border-radius: 50%;
					cursor: pointer;
					img{
						width: 100%;
						height: 100%;
						max-width: 70px;
						max-height: 70px;
						border-radius: 50%;
						object-fit: cover;
					}
				}
				.no_avatar_img{
					cursor: default;
					border: 1px #f1f1f1 solid;
					background-color: #ffffff;
				}
				.el-icon-s-custom{
					margin-top: -10px;
					font-size: 35px;
				}
			}
			.right-box{
				display: flex;
				flex-direction: column;
				margin-left: 10px;
				width: 100%;
				/* width: calc(100% - 206px); */
			}
			.UserInformation-center{
				.name{
					font-weight: 600;
					font-size: 16px;
					color: #111111;
					line-height: 22px;
					text-align: left;
					font-style: normal;
					text-transform: none;
				}
				.browse_browse_box{
					display: flex;
					margin-top: 5px;
					.is_it_me{
						cursor: pointer;
					}
					.icon_box{
						display: flex;
						font-weight: 400;
						font-size: 12px;
						color: #111111;
						line-height: 17px;
						text-align: left;
						font-style: normal;
						text-transform: none;
						margin-right: 26px;
						&:last-child{
							margin-right: 0px;
						}
					}
					.icon_box_text{
						margin-left: 5px;
					}
				}
				.product_list{
					margin-top: 10px;
					display: flex;
					flex-wrap: wrap;
					.product_name{
						font-weight: 400;
						margin-right: 5px;
						margin-bottom: 5px;
						font-size: 8px;
						color: #000000;
						line-height: 8px;
						padding: 3px 15px;
						border-radius: 10px;
						text-align: left;
						font-style: normal;
						text-transform: none;
						border: 1px #000000 solid;
						&:last-child{
							margin-right: 0px;
						}
					}
				}
			}
			.UserInformation-right{
				width: 80px;
				display: flex;
				justify-content: center;
				align-items: center;
				margin-top: 10px;
			}
			.modify_personal_information_box{
				width: 100%;
				height: 100%;
				display: flex;
				justify-content: center;
				align-items: center;
				.modify_personal_information{
					width: 80px;
					height: 28px;
					font-weight: 400;
					font-size: 12px;
					color: #FFFFFF;
					line-height: 14px;
					text-align: center;
					font-style: normal;
					text-transform: none;
					padding: 5px 15px;
					color: #ffffff;
					background: #000000;
					border: 1px #000000 solid;
					border-radius: 15px 15px 15px 15px;
					cursor: pointer;
				}
			}
			.follow_status_box{
				display: flex;
				justify-content: center;
				align-items: center;
				.follow_status{
					width: 80px;
					height: 28px;
					font-weight: 400;
					font-size: 12px;
					color: #FFFFFF;
					line-height: 14px;
					text-align: center;
					font-style: normal;
					text-transform: none;
					padding: 5px 15px;
					border-radius: 15px 15px 15px 15px;
					cursor: pointer;
				}
				.Follow{
					color: #ffffff;
					background: #06f;
					border: 1px #06f solid;
					// background: #2094FA;
					// border: 1px #2094FA solid;
				}
				.Remove{
					color: #ffffff;
					background: #000000;
					border: 1px #000000 solid;
				}
				.Unfollow{
					color: #06f;
					background: #ffffff;
					border: 1px #06f solid;
					// color: #2094FA;
					// background: #ffffff;
					// border: 1px #2094FA solid;
				}
			}
		}
	}
</style>
